import * as React from "react";
import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'

import Dashboard from './Pages/Dashboard'
import AnalyticsDashboard from './Pages/AnalyticsDashboard'
import AdminRoute from './components/AdminRoute'
import Login from './Pages/Login'
import HomeNew from './Pages/HomeNew'
// import ViewListing from './ViewListing'
import './index.css'
import { Provider } from "react-redux";
import { store } from "./redux/store";
import ThankYou from "./Pages/Thankyou";
import Declaration from "./Pages/Declaration";
import Traffic from "./Pages/Traffic";
import DeclarationTraffic from "./Pages/DeclarationTraffic";
import Links from "./Pages/Links";
import StudentSessions from "./Pages/StudentSessions";
import QldEoi from "./Pages/QldEoi";
import ThankyouQld from "./Pages/ThankyouQld";
import SuccessMessage from "./components/SuccessMessage";
import TrafficCourseFlow from "./Pages/TrafficCourseFlow";
import TrafficPracticalAssessment from "./Pages/TrafficPracticalAssessment";
import TrafficDayProgram from "./Pages/TrafficDayProgram";
import BookingPilot from "./Pages/BookingPilot";
import BookingStudentPilot from "./Pages/BookingStudentPilot";

const router = createBrowserRouter([
  { path: '/booking-pilot', element: <BookingPilot /> },
  { path: '/student-pilot', element: <BookingStudentPilot /> },
  { path: '/trafficDayProgram', element: <TrafficDayProgram /> },
  { path: '/trafficPracticalAssessment', element: <TrafficPracticalAssessment /> },
  { path: '/student-sessions', element: <StudentSessions /> },
  {
    path: "/",
    element: <HomeNew />,
  },
  {
    path: "/links",
    element: <Links />,
  },
  {
    path: "/trafficControl",
    element: <Traffic />,
  },
  {
    path: "/trafficImplementation",
    element: <Traffic />,
  },
  {
    path: "/trafficCourseFlow",
    element: <TrafficCourseFlow />,
  },
  {
    path: "/declaration",
    element: <Declaration />,
  },
  {
    path: "/qldEoi",
    element: <QldEoi />,
  },
  {
    path: "/dec-trafficControl",
    element: <DeclarationTraffic />,
  },
  {
    path: "/dec-trafficImplementation",
    element: <DeclarationTraffic />,
  },
  {
    path: "/admin",
    element: <Dashboard />,
  },
  {
    path: "/analytics",
    element: (
      <AdminRoute>
        <AnalyticsDashboard />
      </AdminRoute>
    ),
  },
  {
    path: "/thankyou",
    element: <ThankYou />,
  },
  {
    path: "/thankyouQld",
    element: <ThankyouQld />,
  },
  {
    path: "/login",
    element: <Login />,
  }
])

createRoot(document.getElementById("root")).render(
  <>
    <Provider store={store()}>
      <RouterProvider router={router} />
      <SuccessMessage />
      <ToastContainer />
    </Provider>
  </>
);
